<template>
  <div class="download container">
    <div class="tips" v-show="tipsIsShow">
      点击右上角···按钮，然后在弹出的菜单中，点击“在浏览器打开”，即可安装
    </div>
    <div class="page">
      <img :src="logo" alt="" />
      <h3>
        <img :src="icon" alt="" />&nbsp;&nbsp;<span>{{ pageTitle }}</span>
      </h3>
      <div>
        <div class="content" v-for="(item, index) in downloadList" :key="index">
          <div>
            <span>{{ item.type }}</span>
            &nbsp;<span>{{ item.tag }}</span>
          </div>
          <div>
            版本：<span>{{ item.version }}</span>
          </div>
          <div>
            大小：<span>{{ item.size }}</span>
          </div>
          <div>
            更新时间：<span>{{ item.date }}</span>
          </div>
          <div>
            <a :href="item.url" target="_blank" @click="handleDownloadClick">下载</a>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
/* global
    PUBLIC_DOWNLOAD_TITLE,
    PUBLIC_DOWNLOAD_LOGO,
    PUBLIC_SYSTEM_FLAG,
    PUBLIC_PRODUCT,
    PUBLIC_DOWNLOAD_TYPE,
    android_download_url,
    ios_download_url
*/

export default {
  name: 'Download2',
  data() {
    return {
      pageTitle: PUBLIC_DOWNLOAD_TITLE,
      logo: require('@/assets/' + PUBLIC_DOWNLOAD_LOGO),
      systemFlag: PUBLIC_SYSTEM_FLAG,
      icon: null,
      downloadList: [],
      tipsIsShow: false,
      os: '',
    };
  },
  mounted() {
    if (this.systemFlag === 'android') this.icon = require('@/assets/android_icon.png');
    else if (this.systemFlag === 'ios') this.icon = require('@/assets/ios_icon.png');
    else this.icon = require('@/assets/android_icon.png');

    const ua = navigator.userAgent.toLowerCase();
    String(ua.match(/micromessenger/i)) === 'micromessenger' && (this.os = 'weixin');
    String(ua.match(/mqqbrowser/i)) === 'mqqbrowser' && ua.match(/tbs/i) === 'tbs' && (this.os = 'qq');

    if (this.systemFlag === 'android' || this.systemFlag === '') {
      if (this.os !== '') this.tipsIsShow = true;
      else this.tipsIsShow = false;
    }
    this.initData();
  },
  methods: {
    initData() {
      this.downloadList = [];
      const key = PUBLIC_PRODUCT.toLowerCase().trim();
      const strType = PUBLIC_DOWNLOAD_TYPE.toLowerCase().trim() === 'zd' ? '终端' : '助手';
      const android_url = android_download_url[key].filter(item => item.type === strType);
      const ios_url = ios_download_url[key].filter(item => item.type === strType);
      if (this.systemFlag === 'android') {
        android_url.forEach(item => this.downloadList.push(item));
      } else if (this.systemFlag === 'ios') {
        ios_url.forEach(item => this.downloadList.push(item));
        window.location.href = this.downloadList[0].url;
      } else {
        android_url.forEach(item => this.downloadList.push(item));
      }
    },
    handleDownloadClick(e) {
      switch (this.os) {
        case 'weixin':
        case 'qq':
          if (this.systemFlag === 'android' || this.systemFlag === '') {
            alert('点击右上角···按钮，然后在弹出的菜单中，点击“在浏览器打开”，即可安装');
            e.preventDefault();
          }
          break;
        default:
          this.initData();
          break;
      }
    },
  },
};
</script>
